import { WidgetOptions } from '@csnext/cs-core';
export class IframeWidgetOptions extends WidgetOptions {
  public scrolling: boolean = false;
}
